import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import { FaRegCalendar } from "react-icons/fa";
import "./custom-datepicker.css";
import { PaziaDateRangeHeader } from "./PaziaDateRangeHeader";

interface BaseDatepickerProps<T extends boolean | undefined = undefined>
  extends ReactDatePickerProps<T> {
  disabled?: boolean;
  range?: [Date, Date];
}
export const BaseDatepicker = <T extends boolean | undefined = undefined>({
  disabled,
  range,
  ...rest
}: BaseDatepickerProps<T>) => {
  return (
    <DatePicker
      className={`form-input w-full ${disabled ? classNames.disabled : ""} dark:bg-slate-800`}
      wrapperClassName="w-full dark:bg-slate-800"
      placeholderText="Wybierz datę..."
      calendarClassName="pazia-datepicker dark:bg-slate-600 dark:text-slate-200"
      dayClassName={() =>
        "text-slate-800 dark:text-slate-200 hover:bg-slate-200 hover:dark:bg-slate-700"
      }
      monthClassName={() => "text-slate-800 dark:text-slate-200 border"}
      dateFormat={"dd/MM/yyyy"}
      showIcon
      calendarStartDay={1}
      disabled={disabled}
      locale="pl"
      icon={<FaRegCalendar className="text-slate-600" />}
      renderCustomHeader={(p) => <PaziaDateRangeHeader {...p} range={range} />}
      {...rest}
    />
  );
};
const classNames = {
  disabled:
    "disabled:border-slate-200 dark:disabled:border-slate-700 disabled:bg-slate-100 dark:disabled:bg-slate-700 disabled:text-slate-400 dark:disabled:text-slate-600 disabled:cursor-not-allowed",
};
